import { Providers } from './Providers';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes/router';

export const App = () => {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
};
